import { BrowserRouter, useRoutes } from 'react-router-dom'
import { AppProviders, type AppProvidersProps } from './app/providers'
import { SessionProvider } from './app/session'
import { CartProvider } from './features/cart/CartProvider'
import { appRoutes } from './app/routes'
import { WelcomeLanguage } from './app/WelcomeLanguage'
import { api, tokenStore } from './api/client'
import { createAuthApi } from './features/auth'
import { applySafeTop } from './app/safeArea'
import { syncNativeLanguage } from './app/language'
import { useAppReady } from './app/appReady'
import { lockZoom } from './app/zoom'
import { startSentry } from './app/sentry'
import { env } from './config/env'
import './styles/index.css'
import './features/auth/auth.css'

// Sentry грузится отдельным чанком и только в проде, где задан DSN.
void startSentry(env)
// Отступ под статус-бар нужен до первой отрисовки, иначе шапка дёрнется.
applySafeTop()
lockZoom()
// В Flutter-приложении оболочка узнаёт язык, выбранный здесь раньше.
void syncNativeLanguage()

// Флаги функций в сборке не меняются: список адресов собираем один раз.
const routes = appRoutes()

function AppRoutes() {
  return useRoutes(routes)
}

export type AppProps = Omit<AppProvidersProps, 'children'>

export function App(props: AppProps) {
  // Эффект родителя идёт после детей: к этому кадру первый экран уже смонтирован.
  useAppReady()
  return (
    <AppProviders {...props}>
      <SessionProvider tokenStore={tokenStore} api={createAuthApi(api)}>
        <CartProvider>
          <BrowserRouter>
            <AppRoutes />
            <WelcomeLanguage />
          </BrowserRouter>
        </CartProvider>
      </SessionProvider>
    </AppProviders>
  )
}
